/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import { getApiRoot } from "./api-root.js";

// this method is deleted once it's run
export default () => {
  Cloud.setup &&
    Cloud.setup({
      apiBaseUrl: getApiRoot(),
      methods: REMOTE_ENDPOINTS_GLOBAL,
    });

  return Cloud;
};
